export function findPaymentMethod(lovs, paymentMethodKey) {
  return lovs.payment_method.find((method) => method.key === paymentMethodKey)
}

export function findStatusType(lovs, statusKey) {
  return lovs.status_type.find((status) => status.key === statusKey)
}
